import React from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Input } from '../design-system';

function ResetPasswordPage() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  if (auth && auth.isAuthenticated) { if (typeof window !== 'undefined') window.location.href = '/app/'; return null; }

  // No token in URL — show error
  if (!token) {
    return (
      <div className="auth-page" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="auth-card">
          <h1 style={{ color: '#000' }}>Invalid link</h1>
          <p className="subtitle" style={{ color: '#666' }}>
            This password reset link is missing or invalid. Please request a new one.
          </p>
          <Link to="/forgot-password" className="btn btn-primary btn-block btn-large" style={{ backgroundColor: '#007AFF', textAlign: 'center', display: 'block', marginTop: '1.5rem', textDecoration: 'none', color: '#fff', padding: '12px', borderRadius: '8px' }}>
            Request New Link
          </Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(true);
      } else {
        setError(data.error || data.errors?.[0]?.msg || 'Something went wrong.');
      }
    } catch {
      setError('Connection error. Please try again.');
    }
    setLoading(false);
  };

  if (success) {
    return (
      <div className="auth-page" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="auth-card">
          <h1 style={{ color: '#000' }}>Password reset!</h1>
          <p className="subtitle" style={{ color: '#666' }}>
            Your password has been updated. You can now sign in with your new password.
          </p>
          <Link to="/login" className="btn btn-primary btn-block btn-large" style={{ backgroundColor: '#007AFF', textAlign: 'center', display: 'block', marginTop: '1.5rem', textDecoration: 'none', color: '#fff', padding: '12px', borderRadius: '8px' }}>
            Sign In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="auth-card">
        <h1 style={{ color: '#000' }}>Set new password</h1>
        <p className="subtitle" style={{ color: '#666' }}>Enter your new password below.</p>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <Input
              label="New Password"
              type="password"
              size="lg"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="At least 8 characters"
              autoComplete="new-password"
              minLength={8}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <Input
              label="Confirm Password"
              type="password"
              size="lg"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Type it again"
              autoComplete="new-password"
              minLength={8}
              required
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary btn-block btn-large"
            style={{ backgroundColor: '#007AFF' }}
            disabled={loading}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
